import { ActionPlanAction } from "src/api/client-api/ActionPlan/ActionPlanAction";
import { getActionFieldsTargetProperties } from "../../../EditProperties/ImpactSection/utils";
import { formatComparisonTable, MultiImpactTable } from "./formatComparisonTable";
import { formatImpactSummary, Summary } from "./formatImpactSummary";
import { formatSimpleComparisonTable, SingleImpactTableList } from "./formatSimpleComparisonTable";

type Options = {
    actionPlanAction: ActionPlanAction;
    scoreId: number;
};
export const getImpactData = (options: Options): ImpactDataSummary => {
    const { actionPlanAction, scoreId } = options;

    const impactData = actionPlanAction?.impactData ?? {};
    const actionFields = actionPlanAction.action.actionFields ?? [];

    const actionFieldsForSimple = actionFields.filter((v) => v.isMultivalue === false);
    const targetProperties = getActionFieldsTargetProperties(actionFieldsForSimple);

    const multiActionFields = actionFields.filter((v) => v.isMultivalue);
    const propertiesForMulti = getActionFieldsTargetProperties(multiActionFields);
    const multiImpactTable = formatComparisonTable({
        actionPlanAction,
        impactData,
        selectedScoreId: scoreId,
        targetProperties: propertiesForMulti,
    });

    const simpleImpactTable = formatSimpleComparisonTable({
        actionPlanAction: actionPlanAction,
        targetProperties,
        actionFields: actionFieldsForSimple,
        scoreId: scoreId,
    });

    const summary = formatImpactSummary({
        multiImpactTable,
        simpleImpactTable,
        scoreId: scoreId,
        currentActionPlanAction: actionPlanAction,
    });

    const impactDataSummary = {
        multiImpactTable,
        simpleImpactTable,
        summary,
    };
    return impactDataSummary;
};

export type ImpactDataSummary = {
    multiImpactTable: MultiImpactTable | null;
    simpleImpactTable: SingleImpactTableList | null;
    summary: Summary;
};
